import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

interface ContributionEmptyStateProps {
  searchText?: string;
}

const StyledDiv = styled.div``;

const ContributionEmptyState: React.FC<ContributionEmptyStateProps> = () => {
  return <StyledDiv>No contributions found.</StyledDiv>;
};

export default ContributionEmptyState;
